export default __webpack_public_path__ + "static/media/Tesla.6688b44a.jpg";